import Session from '@/plugins/sdk/resources/Session'
import { CREATED, UPDATED } from '@/plugins/sdk/Events'
import Resource from '@/plugins/sdk/Resource'

export const CREATE = 'create'
export const READ = 'read'
export const UPDATE = 'update'
export const DELETE = 'delete'
export const RESTORE = 'restore'

let user = null
let permissions = null

Session.on([CREATED, UPDATED], (session) => {
  if (session.profile) {
    user = session.profile
    permissions = session.role.permissions
    user.loadConfiguration()
  }
})

function check (abilities, resource) {
  if (!Array.isArray(abilities)) {
    abilities = [abilities]
  }

  if (!abilities.every(ability => isAbility(ability))) {
    throw new TypeError('Every ability must be one of the pre-defined constants')
  }

  if (resource instanceof Resource) {
    resource = resource.constructor.name
  } else if (resource.prototype instanceof Resource) {
    resource = resource.name
  } else if (typeof resource !== 'string') {
    throw new TypeError('Resource must be of type String or instanceof Resource. ' + typeof resource + ' given.')
  }

  const permission = permissions.find(element => element.resource === resource)

  if (permission) {
    return abilities.every(ability => permission.$fields[ability].current)
  } else {
    return false
  }
}

function isAbility (ability) {
  switch (ability) {
    case CREATE:
      return true
    case READ:
      return true
    case UPDATE:
      return true
    case DELETE:
      return true
    case RESTORE:
      return true
    default:
      return false
  }
}

export default function install (Vue) {
  Object.defineProperty(Vue.prototype, '$user', {
    value: {
      get instance () {
        return user
      },
      can (abilities, resource) {
        return check(abilities, resource)
      },
      cannot (abilities, resource) {
        return !check(abilities, resource)
      }
    }
  })
}
